import { Component } from '@angular/core';

@Component({
  selector: 'app-tous-fac-f',
  templateUrl: './tous-fac-f.component.html',
  styleUrls: ['./tous-fac-f.component.scss']
})
export class TousFacFComponent {}
